export default {
  Title: 'Partner',
  AddPartner: 'Add Partner',
  EditPartner: 'Edit Partner',
  Delete: 'Delete',
  Search: 'Search',
  PartnerID: 'Partner ID',
  PartnerName: 'Partner name',
  Country: 'Country',
  Sales: 'Sales',
  AddressLine: 'Address line',
  City: 'City',
  State: 'State/province/region',
  ZipCode: 'Zip code',
  Email: 'Email',
  Active: 'Active',
  DateCreated: 'Created date',
  Status: 'Status',
  GeneralInfo: 'General information',
  AgencyRepresentative: 'Agency Representative',
  OtherInfo: 'Other Information',
  FullName: 'Full name',
  PhoneNumber: 'Phone number',
  Role: 'Role',
  NewPurchaseDiscountRate: 'New purchase discount rate (%)',
  RenewalDiscountRate: 'Renewal discount rate (%)',
  DevicePurchaseDiscountRate: 'Device purchase discount rate (%)',
  AddOnFeaturePurchaseDiscountRate: 'Add-on feature purchase discount rate (%)',
  Currency: 'Currency',
  PaymentMethod: 'Payment method',
  TotalPartner: 'Total: {number} partners',
  OverTime: '{date} days ago',
  Today: 'Today',
  AddPartnerSuccess: 'Add partner successfully',
  AddPartnerFail: 'Add partner failed',
  EditPartnerSuccess: 'Edit partner successfully',
  EditPartnerFail: 'Edit partner failed',
  Save: 'Save',
  Cancel: 'Cancel',
  AcceptDelete: 'Are you sure you want to delete this partner?',
  CannotDeletePartner: 'You cannot delete this Partner because they have already submitted a request.',
  PartnerType: 'Partner type',
};
